import { getUsers, updateUser, updateAccess } from '../../../../actions/UserActions';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { GET_ERRORS, UPDATE_USER } from '../../../../actions/types';
import { getFaculties } from '../../../../actions/FacultyActions';
import UserAccessModalComponent from './UserAccessModalComponent';
import { getDenials } from '../../../../actions/DenyActions';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { getRoles } from '../../../../actions/RolActions';
import BootstrapTable from 'react-bootstrap-table-next';
import LoadingOverlay from 'react-loading-overlay';
import Snackbar from '@material-ui/core/Snackbar';
import { TextField } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import docs from '../../../../config/docs';
import React, { Component } from 'react';
import { Combobox } from 'react-widgets';
import { connect } from 'react-redux';
import './UserListComponent.scss';
import '../MainContent.scss';


const URL = docs.docsUsers;

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class UserListComponent extends Component {
	///---------------------------------------INIT-------------------------------------

	state = {
		selectedId: 0,
		users: [],
		activeLoader: true,
		showSnackBar: false,
		textSnackBar: "",
		severitySnackBar: "success",
		addModalIsVisible: false,
		roles:["B2B", "PREV", "CMS"],
		skip: 1,
		search: "",
		modalType: "NORMAL"
		
	};

	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onChangeRol = this.onChangeRol.bind(this);
		this.openModal = this.openModal.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}

	componentDidMount() {
		this.setState({
			activeLoader: true,
		});
		this.props.getUsers(this.state.skip, this.state.roles, null);
		this.props.getRoles({is_active: true});
		this.props.getFaculties({is_active: true});
		this.props.getDenials({is_active: true});
	}

	componentDidUpdate(prevProps) {
		if (this.props.users !== this.state.users) {
			this.setState({
				users: this.props.users,
				activeLoader: false,
			});
		} 
		else if (this.props.actionType === UPDATE_USER && prevProps.actionType !== UPDATE_USER) {
			this.props.getUsers(this.state.skip, this.state.roles, null);
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Usuario actualizado exitosamente.",
				severitySnackBar: "success",
			});
		} 
		else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: this.props.error,
				severitySnackBar: "error",
			});
		}
	}

	///---------------------------------------EVENTS-------------------------------------


	handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		this.setState({
			showSnackBar: false,
		});
	};

	openModal = () => {
		this.setState({
			addModalIsVisible: true,
			modalType: "NORMAL",
		});
	};

	handleUpdate(user) {

		this.setState({
			activeLoader: true,
			addModalIsVisible: false,
		});

		this.props.updateAccess(
			user._id,
			user.roles,
			user.faculties,
			user.denies
		);
	}

	handleCancel() {
		this.setState({
			addModalIsVisible: false,
			userData: null,
		});
	}

	onChange(e) {
		e.persist();
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	onChangeRol(rol) {
		let keys = [];
		keys.push(rol.key);
		this.setState({
			roles: keys,
			skip:1
		}, () => {
			this.pagination();
		});
		
	}

	onSearch() {
		if (this.state.search.length > 0) {
			this.setState(
				{
					skip: 1,
				},
				() => {
					let search = "&search=" + this.state.search;
					this.setState({
						activeLoader: true,
					});
					this.props.getUsers(this.state.skip, this.state.roles, search);
				}
			);
		}
	}

	redirectTo() {
		const newWindow = window.open(URL, "_blank", "noopener,noreferrer");
		if (newWindow) newWindow.opener = null;
	}

	pagination() {
		this.setState({
			activeLoader: true,
		});

		let search = "&search=" + this.state.search;
		this.props.getUsers(this.state.skip, this.state.roles, search);
	}

	///---------------------------------------VIEW-------------------------------------

	render() {
		const customOptions = {
			noDataText:
				'<div className="color-red">No hay datos disponibles para su consulta.</div>',
		};


		const columns = [
			{
				dataField: "nombre",
				text: "Nombre",
				formatter: (cell) => {
					return cell.toUpperCase();
				},
			},
			{
				dataField: "email",
				text: "Email",
			},
			{
				dataField: "roles",
				text: "Rol",
				formatter: (cell) => {
					if (cell) {
						if (cell.length > 2) return "------";
						else if (cell.includes("B2B")) return "CLIENTE";
						else if (cell.includes("PREV")) return "PREVENTISTA";
						else if (cell.includes("CMS")) return "CMS";
						else if (cell.includes("API")) return "API";
					}
				},
			},
			{
				dataField: "centroFarmazon.nombre",
				text: "Centro Farmazon",
				formatter: (cell) => {
					if (cell) return cell.toUpperCase();
				},
			},
			{
				dataField: "is_active",
				text: "Estatus",
				formatter: (cell) => {
					return cell === true ? "Activo" : "Inactivo";
				},
			},
		];

		const rowEvents = {
			onClick: (e, row, rowIndex) => {
				let user = this.state.users[rowIndex];
				this.setState({
					modalType: "UPDATE",
					user: user,
					addModalIsVisible: !this.state.addModalIsVisible,
					defaultInnerBranchId: row.innerBranchId,
				});
			},
		};

		const total = this.props.total;
		const totalPages = Math.ceil(total / 10);

		return (
			<div className="main-content">
				<div className="toolbar100 space">
					<TextField
						style={{ height: "7%", width: "30%" }}
						id="input-search"
						label="Buscar."
						name="search"
						inputProps={{ style: { fontSize: "1.1rem" } }}
						InputLabelProps={{ style: { fontSize: "0.6rem" } }}
						onChange={this.onChange}
						value={this.state.search}
						size="medium"
					/>
					<Combobox
						style={{ height: "100%", width: "30%" }}
						placeholder="Rol"
						valueField="key"
						dataKey="key"
						textField="name"
						data={this.props.roles}
						onChange={this.onChangeRol}
			
					/>
			
					<button
						className="edit-buttonOK"
						onClick={this.onSearch}
						style={{
							width: "10%",
							marginTop: "1%",
							marginRight: "3.5%",
							fontSize: "0.7rem",
						}}
					>
						Buscar
					</button>
					
				</div>

				<div className="user-category-wrapper">
					<ToolkitProvider
						keyField="_id"
						striped
						hover
						condensed
						data={this.state.users}
						options={customOptions}
						columns={columns}
						rowEvents={rowEvents}
					>
						{(props) => (
							<div style={{ textAlign: "left" }}>
								<BootstrapTable
									rowEvents={rowEvents}
									headerWrapperClasses="title-table"
									rowClasses="custom-row-table"
									{...props.baseProps}
								/>
							</div>
						)}
					</ToolkitProvider>

					<br></br>

					<div className="toolbar100 end">
						<button
							className={
								this.state.skip !== 1
									? "modalButtonPager"
									: "modalButtonPager disabled"
							}
							onMouseDown={(e) => {
								e.preventDefault();
								this.setState(
									{
										skip: this.state.skip - 1,
									},
									() => {
										this.pagination();
									}
								);
							}}
							disabled={this.state.skip === 1 ? true : false}
						>
							« Anterior
						</button>

						<button
							className={
								this.state.skip < totalPages
									? "modalButtonPager"
									: "modalButtonPager disabled"
							}
							onMouseDown={(e) => {
								e.preventDefault();
								this.setState(
									{
										skip: this.state.skip + 1,
									},
									() => {
										this.pagination();
									}
								);
							}}
							disabled={this.state.skip < totalPages ? false : true}
						>
							Siguiente »
						</button>
					</div>
				</div>

				<UserAccessModalComponent
					isVisible={this.state.addModalIsVisible}
					type={this.state.modalType}
					handleCancel={this.handleCancel}
					handleUpdate={this.handleUpdate}
					user={this.state.user}
					faculties={this.props.faculties}
					roles={this.props.roles}
					denies={this.props.denies}
				/>
				
				{
					<LoadingOverlay
						active={this.state.activeLoader}
						isVisible={this.state.activeLoader}
						spinner
						text="Esto puede tardar unos minutos"
						styles={{
							wrapper: {
								width: this.state.activeLoader ? "100%" : "0%",
								height: this.state.activeLoader ? "100%" : "0%",
							},
							overlay: (base) => ({
								...base,
								background: "rgba(10, 10, 10, 0.7)",
							}),
						}}
					></LoadingOverlay>
				}
				{
					<Snackbar
						open={this.state.showSnackBar}
						autoHideDuration={6000}
						onClose={this.handleClose}
					>
						<Alert
							onClose={this.handleClose}
							severity={this.state.severitySnackBar}
						>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	users: state.user_reducer.clients,
	total: state.user_reducer.total,
	actionType: state.user_reducer.actionType,
	error: state.user_reducer.error,
	auth: state.auth,
	roles: state.rol_reducer.roles,
	faculties: state.faculty_reducer.faculties,
	denies: state.deny_reducer.denies,
});

export default connect(mapStateToProps, {
	getUsers,
	updateUser,
	updateAccess,
	getDenials,
	getFaculties,
	getRoles
})(UserListComponent);
